import { createApi } from "@reduxjs/toolkit/query/react";
import   {appBaseQuery} from "../services/baseQuery"


export const rfidRegistrationSliceApi = createApi({
  reducerPath: "rfidRegistrationSliceApi",
    baseQuery:appBaseQuery,
  tagTypes: ["RfidRegistration"],

  endpoints: (builder) => ({
    // ✅ GET RFID Registrations (list)
    getRfidRegistrations: builder.query({
      query: ({ page = 1, limit = 10 } = {}) =>
        `rfid-registration/?page=${page}&limit=${limit}`,
      providesTags: ["RfidRegistration"],
    }),

    // ✅ GET Dropdown
getRfidDropdown: builder.query({
  query: () => `rfid-registration/dropdown/`,
  providesTags: ["RfidRegistration"],
}),

    // ✅ POST (Register RFID)
    addRfidRegistration: builder.mutation({
      query: (payload) => ({
        url: "rfid-registration/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["RfidRegistration"],
    }),


    // ✅ PUT (Update RFID Registration)
    updateRfidRegistration: builder.mutation({
      query: ({ id, ...updatedData }) => ({
        url: `rfid-registration/${id}/`,
        method: "PUT",
        body: updatedData,
      }),
      invalidatesTags: ["RfidRegistration"],
    }),

    // ✅ DELETE RFID Registration
    deleteRfidRegistration: builder.mutation({
      query: (id) => ({
        url: `rfid-registration/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["RfidRegistration"],
    }),
  }),
});

export const {
  useGetRfidRegistrationsQuery,
  useAddRfidRegistrationMutation,
  useUpdateRfidRegistrationMutation,
  useDeleteRfidRegistrationMutation,
  useGetRfidDropdownQuery,
} = rfidRegistrationSliceApi;
